/* Prime Organics 2026 homepage runtime (po26-*). Port of nt-2026.js plus:
   hero motion loops, the "moments" routine builder and the PDP buy path. */
(function () {
  var D = window.PO26 || {};
  /* Native fetch, taken before po-cart-drawer.js (header-group) wraps it: that wrapper opens
     the drawer on every /cart/clear|add, which would flash it mid-redirect. This file loads
     deferred from <head>, so it runs before the drawer's own deferred script. Same as vpo.js. */
  var nativeFetch = window.fetch ? window.fetch.bind(window) : null;
  var money = function (c) { return '$' + (c / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); };
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var saveData = navigator.connection && navigator.connection.saveData;

  function ready(fn) {
    if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {

  /* ---------- buy path: identical to the PDP (vp-bp) ----------
     clear cart -> add VP (+ 30-day plan + three $0 gift lines carrying their drawer slot)
     -> /checkout. If the gift lines are refused, retry the probiotic alone. */
  var busy = false;
  function post(url, body) {
    var f = nativeFetch || window.fetch;
    return f(url, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body || {})
    }).then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { return { ok: r.ok, j: j }; }); });
  }
  function buy(btn) {
    if (busy || !D.variant) return;
    var once = btn.hasAttribute('data-once');
    var src = btn.getAttribute('data-po26-buy') || 'home';
    busy = true;
    btn.setAttribute('aria-busy', 'true');
    var label = btn.textContent;
    btn.textContent = 'One moment...';
    $$('[data-po26-err]').forEach(function (el) { el.hidden = true; });
    var main = { id: D.variant, quantity: 1, properties: { _vpo_src: 'po26-' + src } };
    if (!once && D.plan) main.selling_plan = D.plan;
    var gifts = once ? [] : (D.gifts || []).map(function (g) { return { id: g.v, quantity: 1, properties: { _gift: String(g.slot || '') } }; });
    post('/cart/clear.js')
      .then(function () { return post('/cart/add.js', { items: [main].concat(gifts) }); })
      .then(function (r) { return (r.ok || !gifts.length) ? r : post('/cart/add.js', { items: [main] }); })
      .then(function (r) {
        if (!r.ok) throw new Error((r.j && (r.j.description || r.j.message)) || '');
        window.location.href = '/checkout';
      })
      .catch(function (e) {
        busy = false;
        btn.removeAttribute('aria-busy');
        btn.textContent = label;
        var box = btn.closest('.po26-tray, .po26-stacks');
        /* buttons with no error slot (hero-adjacent, shelf, close, sticky): fall back to the PDP */
        if (!box) { window.location.href = '/products/vaginal-probiotic'; return; }
        $$('[data-po26-err]', box).forEach(function (el) {
          el.textContent = (e && e.message) || 'Something went wrong. Please try again.';
          el.hidden = false;
        });
      });
  }
  $$('[data-po26-buy]').forEach(function (b) {
    if (b.classList.contains('po26-tray__btn')) return; /* the builder wires its own */
    b.addEventListener('click', function () { buy(b); });
  });

  /* ---------- hero slider + motion loops ----------
     Each slide carries a <video> with NO src. Only the live slide's loop is attached, after
     the window load event, and only when motion and data are welcome. The still plate stays
     underneath, so a slow or refused video never shows a gap. */
  (function () {
    var root = $('.po26-hero'); if (!root) return;
    var slides = $$('.po26-hero__slide', root), dots = $$('.po26-hero__dot', root);
    var phone = window.matchMedia('(max-width:640px)');
    var motionOK = !calm && !saveData, loaded = false;
    var i = 0, timer, held = false;
    /* 9s per slide, held while she is reading (hover) or touching the hero */
    root.addEventListener('mouseenter', function () { held = true; });
    root.addEventListener('mouseleave', function () { held = false; });
    root.addEventListener('pointerdown', function () { held = true; setTimeout(function () { held = false; }, 6000); });

    function vidOf(s) { return $('.po26-hero__vid', s); }
    function playVid(s) {
      var v = vidOf(s); if (!v || !motionOK || !loaded) return;
      var want = v.getAttribute(phone.matches ? 'data-src-m' : 'data-src-d');
      if (!want) return;
      if (v.getAttribute('src') !== want) {
        v.classList.remove('is-live');
        v.src = want;
        v.addEventListener('playing', function on() { v.classList.add('is-live'); v.removeEventListener('playing', on); });
      }
      v.muted = true;
      var pr = v.play(); if (pr && pr.catch) pr.catch(function () {});
    }
    function stopVid(s) { var v = vidOf(s); if (v && !v.paused) v.pause(); }

    function go(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) {
        var on = k === i;
        s.classList.toggle('on', on);
        if (on) playVid(s); else stopVid(s);
      });
      dots.forEach(function (d, k) { d.classList.toggle('on', k === i); });
    }
    function play() { clearInterval(timer); if (slides.length > 1) timer = setInterval(function () { if (!held) go(i + 1); }, 9000); }
    var prev = $('.po26-hero__arrow--l', root), next = $('.po26-hero__arrow--r', root);
    if (prev) prev.addEventListener('click', function () { go(i - 1); play(); });
    if (next) next.addEventListener('click', function () { go(i + 1); play(); });
    dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); play(); }); });

    var x0 = null, y0 = null;
    root.addEventListener('touchstart', function (e) { var t = e.changedTouches[0]; x0 = t.clientX; y0 = t.clientY; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var t = e.changedTouches[0], dx = t.clientX - x0, dy = t.clientY - y0; x0 = null;
      if (Math.abs(dx) < 44 || Math.abs(dx) < Math.abs(dy)) return;
      go(dx < 0 ? i + 1 : i - 1); play();
    }, { passive: true });

    /* pause the loop and the clock when the hero is off screen or the tab is hidden */
    var visible = true;
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        visible = es[0].isIntersecting;
        if (visible) { playVid(slides[i]); play(); } else { stopVid(slides[i]); clearInterval(timer); }
      }, { threshold: 0.15 }).observe(root);
    }
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stopVid(slides[i]); else if (visible) playVid(slides[i]);
    });
    function arm() { loaded = true; if (visible) playVid(slides[i]); }
    if (document.readyState === 'complete') setTimeout(arm, 300);
    else window.addEventListener('load', function () { setTimeout(arm, 300); });
    if (phone.addEventListener) phone.addEventListener('change', function () { playVid(slides[i]); });
    play();
  })();

  /* ---------- video reel (endless rail, only the centred card plays) ---------- */
  (function () {
    var reel = $('.po26-reel'); if (!reel) return;
    var rail = $('.po26-reel__rail', reel),
        sound = $('[data-reel-sound]', reel), label = $('[data-reel-sound-label]', reel),
        prev = $('[data-reel-prev]', reel), next = $('[data-reel-next]', reel);
    if (!rail) return;
    var cards = $$('.po26-reel__card', reel); if (!cards.length) return;
    var active = -1, wanted = false, onScreen = false, unmuted = false, aim = -1;

    var setSize = cards.length, looping = setSize > 1;
    if (looping) {
      var before = document.createDocumentFragment(), after = document.createDocumentFragment();
      cards.forEach(function (c) {
        [before, after].forEach(function (frag) {
          var k = c.cloneNode(true);
          k.setAttribute('data-reel-clone', ''); k.setAttribute('aria-hidden', 'true'); k.setAttribute('tabindex', '-1');
          frag.appendChild(k);
        });
      });
      rail.insertBefore(before, rail.firstChild);
      rail.appendChild(after);
      cards = $$('.po26-reel__card', reel);
    }
    function setW() { return looping ? cards[setSize].offsetLeft - cards[0].offsetLeft : 0; }
    function vid(k) { return cards[k] ? $('video', cards[k]) : null; }
    function playAt(k) {
      var v = vid(k); if (!v) return;
      if (!v.src) v.src = cards[k].getAttribute('data-src');
      v.muted = !unmuted;
      var pr = v.play(); if (pr && pr.catch) pr.catch(function () {});
    }
    function halt(k) { var v = vid(k); if (!v) return; v.pause(); try { v.currentTime = 0; } catch (e) {} }
    function setActive(k, force) {
      if (k === active && !force) return;
      if (active > -1 && cards[active]) { cards[active].classList.remove('is-active'); halt(active); }
      active = k;
      cards[k].classList.add('is-active');
      if (onScreen && !calm && !saveData) playAt(k);
    }
    function nearest() {
      var box = rail.getBoundingClientRect(), mid = box.left + box.width / 2, best = 0, bestd = Infinity;
      cards.forEach(function (c, k) { var r = c.getBoundingClientRect(), d = Math.abs(r.left + r.width / 2 - mid); if (d < bestd) { bestd = d; best = k; } });
      return best;
    }
    function normalise(k) {
      if (!looping) return k;
      var w = setW(); if (!w) return k;
      if (k < setSize) { rail.scrollLeft += w; if (aim > -1) aim += setSize; return k + setSize; }
      if (k >= setSize * 2) { rail.scrollLeft -= w; if (aim > -1) aim -= setSize; return k - setSize; }
      return k;
    }
    var gliding = false, settle;
    rail.addEventListener('scroll', function () {
      clearTimeout(settle);
      settle = setTimeout(function () { gliding = false; setActive(normalise(nearest())); aim = active; }, 150);
      if (wanted) return;
      wanted = true;
      requestAnimationFrame(function () { wanted = false; var k = nearest(); if (!gliding) k = normalise(k); setActive(k); });
    }, { passive: true });
    function go(k) {
      if (looping) {
        var w0 = setW();
        if (w0) { while (k < setSize) { rail.scrollLeft += w0; k += setSize; } while (k >= setSize * 2) { rail.scrollLeft -= w0; k -= setSize; } }
      }
      k = Math.max(0, Math.min(cards.length - 1, k));
      aim = k; gliding = true;
      var box = rail.getBoundingClientRect(), r = cards[k].getBoundingClientRect();
      rail.scrollBy({ left: (r.left + r.width / 2) - (box.left + box.width / 2), behavior: calm ? 'auto' : 'smooth' });
      setActive(k);
    }
    function step(d) { go((aim < 0 ? active : aim) + d); }
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    if (sound) sound.addEventListener('click', function () {
      unmuted = !unmuted;
      sound.setAttribute('aria-pressed', unmuted ? 'true' : 'false');
      if (label) label.textContent = unmuted ? 'Sound on' : 'Sound off';
      var v = vid(active); if (v) { v.muted = !unmuted; if (unmuted) playAt(active); }
    });
    cards.forEach(function (c, k) {
      c.addEventListener('click', function () {
        if (k !== active) { go(k); return; }
        if (window.PO26lightbox) window.PO26lightbox(c);
      });
    });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        onScreen = es[0].isIntersecting;
        if (onScreen) { if (!calm && !saveData) playAt(active); } else if (active > -1) halt(active);
      }, { threshold: 0.25 }).observe(reel);
    } else { onScreen = true; }
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { if (active > -1) halt(active); } else if (onScreen && !calm && !saveData) playAt(active);
    });
    var home = looping ? setSize : 0; /* Jen D. first: the cleanest, strongest clip */
    setActive(home, true); go(home); aim = home;
  })();

  /* ---------- shared lightbox (reel cards + review-wall video tiles) ---------- */
  (function () {
    var lb = $('.po26-lb'); if (!lb) return;
    var v = $('.po26-lb__vid', lb), box = $('.po26-lb__box', lb),
        nm = $('#po26-lb-name', lb), pd = $('[data-lb-prod]', lb), qt = $('[data-lb-quote]', lb),
        x = $('[data-lb-close]', lb), last = null, scrollY = 0;
    function open(src) {
      last = document.activeElement;
      nm.textContent = src.getAttribute('data-name') || '';
      pd.textContent = src.getAttribute('data-prod') || '';
      qt.textContent = src.getAttribute('data-quote') ? '“' + src.getAttribute('data-quote') + '”' : '';
      v.src = src.getAttribute('data-src'); v.muted = false;
      lb.classList.add('is-open');
      scrollY = window.pageYOffset;
      document.body.style.position = 'fixed'; document.body.style.top = -scrollY + 'px'; document.body.style.width = '100%';
      if (x) x.focus();
      var pr = v.play(); if (pr && pr.catch) pr.catch(function () {});
    }
    function close() {
      if (!lb.classList.contains('is-open')) return;
      lb.classList.remove('is-open');
      v.pause(); v.removeAttribute('src'); v.load();
      document.body.style.position = ''; document.body.style.top = ''; document.body.style.width = '';
      window.scrollTo(0, scrollY);
      if (last && last.focus) last.focus();
    }
    window.PO26lightbox = open;
    if (x) x.addEventListener('click', close);
    lb.addEventListener('click', function (e) { if (!box.contains(e.target)) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' || e.keyCode === 27) close(); });
    $$('[data-lb-open]').forEach(function (t) { t.addEventListener('click', function () { open(t); }); });
  })();

  /* ---------- accordions ---------- */
  function accordion(rowSel, btnSel, bodySel, single) {
    $$(rowSel).forEach(function (row) {
      var btn = $(btnSel, row), body = $(bodySel, row); if (!btn || !body) return;
      btn.setAttribute('aria-expanded', 'false');
      btn.addEventListener('click', function () {
        var open = row.classList.contains('on');
        if (single) $$(rowSel).forEach(function (r) {
          r.classList.remove('on'); var b = $(bodySel, r); if (b) b.style.maxHeight = 0;
          var q = $(btnSel, r); if (q) q.setAttribute('aria-expanded', 'false');
        });
        if (!open) { row.classList.add('on'); body.style.maxHeight = body.scrollHeight + 'px'; btn.setAttribute('aria-expanded', 'true'); }
        else { row.classList.remove('on'); body.style.maxHeight = 0; btn.setAttribute('aria-expanded', 'false'); }
      });
    });
  }
  accordion('.po26-acc__row', '.po26-acc__q', '.po26-acc__a', true);
  accordion('.po26-q', '.po26-q__q', '.po26-q__a', true);
  accordion('.po26-badge', '.po26-badge__top', '.po26-badge__a', false);

  /* ---------- count-up stats ---------- */
  (function () {
    var nodes = $$('[data-count]'); if (!nodes.length || !window.IntersectionObserver) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target, end = parseFloat(el.getAttribute('data-count')), dec = (end % 1 !== 0) ? 1 : 0;
        var suffix = el.getAttribute('data-suffix') || '', t0 = null;
        if (calm) { el.textContent = (dec ? end.toFixed(1) : end.toLocaleString('en-US')) + suffix; io.unobserve(el); return; }
        function stepf(ts) {
          if (!t0) t0 = ts;
          var p = Math.min((ts - t0) / 1400, 1), val = end * (1 - Math.pow(1 - p, 3));
          el.textContent = (dec ? val.toFixed(1) : Math.round(val).toLocaleString('en-US')) + suffix;
          if (p < 1) requestAnimationFrame(stepf);
        }
        requestAnimationFrame(stepf);
        io.unobserve(el);
      });
    }, { threshold: .4 });
    nodes.forEach(function (n) { io.observe(n); });
  })();

  /* ---------- balance band: arm the gauge on scroll ---------- */
  (function () {
    var band = $('.po26-elev'); if (!band) return;
    if (!window.IntersectionObserver) { band.classList.add('is-in'); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (!e.isIntersecting) return; band.classList.add('is-in'); io.disconnect(); });
    }, { threshold: .28 });
    io.observe(band);
  })();

  /* ---------- label rotator ---------- */
  (function () {
    var cards = $$('.po26-lab__slide'); if (cards.length < 2) return;
    var shots = $$('.po26-lab__shot'), idx = $('.po26-lab__idx'), i = 0, auto;
    function go(n) {
      i = (n + cards.length) % cards.length;
      cards.forEach(function (c, k) { c.style.display = k === i ? '' : 'none'; });
      shots.forEach(function (s, k) { s.classList.toggle('is-on', k === i); });
      if (idx) idx.textContent = ('0' + (i + 1)).slice(-2) + ' / ' + ('0' + cards.length).slice(-2);
    }
    function start() { if (calm) return; clearInterval(auto); auto = setInterval(function () { go(i + 1); }, 5200); }
    var p = $('.po26-lab__prev'), n = $('.po26-lab__next');
    if (p) p.addEventListener('click', function () { go(i - 1); start(); });
    if (n) n.addEventListener('click', function () { go(i + 1); start(); });
    go(0);
    var panel = $('.po26-lab__panel');
    if (panel && window.IntersectionObserver) new IntersectionObserver(function (es) {
      if (es[0].isIntersecting) start(); else clearInterval(auto);
    }, { threshold: .4 }).observe(panel);
  })();

  /* ---------- guides carousel ---------- */
  (function () {
    var rail = $('.po26-jgrid'); if (!rail) return;
    var p = $('.po26-journal__prev'), n = $('.po26-journal__next');
    function step() { var c = $('.po26-jcard', rail); return c ? c.offsetWidth + 20 : 320; }
    if (p) p.addEventListener('click', function () { rail.scrollLeft -= step(); });
    if (n) n.addEventListener('click', function () { rail.scrollLeft += step(); });
  })();

  /* ---------- mobile sticky buy bar ----------
     On once the hero has scrolled away; off while the builder tray or the offer cards are
     visible (they carry their own buy buttons) and while the footer is on screen. */
  (function () {
    var bar = $('[data-po26-sticky]'); if (!bar || !window.IntersectionObserver) return;
    var heroGone = false, blockers = 0, seen = new Map();
    function paint() {
      var on = heroGone && blockers === 0;
      bar.classList.toggle('is-on', on);
      var b = $('button', bar); if (b) b.tabIndex = on ? 0 : -1;
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
    }
    var hero = $('.po26-hero');
    if (hero) new IntersectionObserver(function (es) { heroGone = !es[0].isIntersecting; paint(); }, { threshold: 0 }).observe(hero);
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { seen.set(e.target, e.isIntersecting); });
      blockers = 0; seen.forEach(function (v) { if (v) blockers++; }); paint();
    }, { threshold: 0.15 });
    $$('.po26-tray, .po26-stacks__grid, .po26-foot').forEach(function (el) { io.observe(el); });
    paint();
  })();

  /* ---------- routine builder ----------
     Same real cart for every combination (VP on the plan + three gifts); the moments she
     taps decide which reasons are printed under the probiotic, so she reads her own month back. */
  (function () {
    var root = $('.po26-ritual'); if (!root) return;
    var goals = $$('.po26-goal', root), tray = $('.po26-tray__body', root), empty = $('.po26-tray__empty', root);
    var stateEl = $('.po26-tray__state', root), btn = $('.po26-tray__btn', root), picked = [];
    var esc = function (s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
    function row(cls, img, name, sub, price) {
      return '<div class="po26-titem ' + cls + '"><img src="' + img + '" alt="" loading="lazy">' +
        '<div class="po26-titem__b"><div class="po26-titem__n">' + name + '</div>' + sub + '</div>' +
        '<div class="po26-titem__p">' + price + '</div></div>';
    }
    function render() {
      if (!picked.length) {
        tray.innerHTML = '';
        empty.style.display = '';
        stateEl.textContent = 'Awaiting moments';
        btn.disabled = true;
        btn.textContent = 'Pick a moment to start';
        return;
      }
      empty.style.display = 'none';
      var whys = picked.map(function (g) { return '<li>' + esc(D.why[g] || '') + '</li>'; }).join('');
      var html = row('po26-titem--hero', D.img.vp, 'Vaginal Probiotic',
        '<div class="po26-titem__w">2 capsules a day &middot; every 30 days</div><ul class="po26-titem__why">' + whys + '</ul>',
        money(D.sub) + '<s>' + money(D.price) + '</s>');
      html += row('po26-titem--gift', D.img.de, 'Complete Digestive Probiotic', '<div class="po26-titem__w">60 vegan capsules, in your first box</div>', '<em>Free</em>');
      html += row('po26-titem--gift', D.img.book, 'Down There, Explained', '<div class="po26-titem__w">The 18-page guide</div>', '<em>Free</em><s>$19</s>');
      html += row('po26-titem--gift', D.img.app, 'Daily Balance Tracker', '<div class="po26-titem__w">See your routine build, week by week</div>', '<em>Free</em><s>$12</s>');
      tray.innerHTML = html;
      stateEl.textContent = picked.length + (picked.length === 1 ? ' moment' : ' moments') + ' covered';
      btn.disabled = false;
      btn.textContent = 'Start my routine · ' + money(D.sub);
    }
    goals.forEach(function (g) {
      g.setAttribute('aria-pressed', 'false');
      g.addEventListener('click', function () {
        var key = g.getAttribute('data-goal'), at = picked.indexOf(key);
        if (at < 0) { picked.push(key); g.classList.add('on'); g.setAttribute('aria-pressed', 'true'); }
        else { picked.splice(at, 1); g.classList.remove('on'); g.setAttribute('aria-pressed', 'false'); }
        render();
      });
    });
    btn.addEventListener('click', function () { if (picked.length) buy(btn); });
    render();
  })();

  });
})();
